import React, { useEffect, useState } from 'react';
import { Container, ImageWrapper, Overlay, ContentWrapper, Title, Description } from './styles';
import CachedImg from 'components/common/CachedImg/CachedImg';
import { isValidUrl } from 'utils/validations/url_validation';
import { getImageAuthURLAsync } from 'components/main/common/utils';

/**
 * TV-Optimized Service Card
 * Large interactive card for main services (Live TV, Room Services, etc.)
 */
export default function ServiceCard({
  title,
  description,
  backgroundImage,
  active,
  onClick,
  className,
}) {
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
  useEffect(() => {
    async function getBackgroundImageUrl() {
      let url = '';
      if (!isValidUrl(backgroundImage)) {
        url = backgroundImage;
      } else {
        url = await getImageAuthURLAsync(backgroundImage);
      }
      setBackgroundImageUrl(url);
    }
    getBackgroundImageUrl();
  }, [backgroundImage]);

  return (
    <Container active={active} onClick={onClick} className={className}>
      {backgroundImageUrl && (
        <ImageWrapper active={active}>
          <CachedImg src={backgroundImageUrl} alt={title} />
        </ImageWrapper>
      )}
      <Overlay active={active} />
      <ContentWrapper>
        <Title active={active}>{title}</Title>
        <Description active={active}>{description}</Description>
      </ContentWrapper>
    </Container>
  );
}
